<script setup>
import { computed, inject, onBeforeMount, onBeforeUnmount } from 'vue'
import OrderEnded from './components/OrderEnded.vue';
import ContactBox from '@/stories/_G-COMPONENTS/contact-box/ContactBox.vue';
import { useCheckoutStore } from '@/stores/checkout.store'
import { isEmpty } from 'lodash'
const $checkout = useCheckoutStore()

const contactUsSection = computed(() => {
  return $checkout?.checkout5?.data?.data?.contact_us_section || null
})

const serviceBoxesTitle = computed(() => {
  return $checkout?.checkout5?.data?.data?.main_content?.boxes_html_title || null
})

const serviceBoxes = computed(() => {
  return $checkout?.checkout5?.data?.data?.main_content?.boxes_html || null
})

const iconPhone = window.webGlobe.global.getSvgDataForImageSrc(`<svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
  <path d="M34.6656 40.9834C34.4823 40.9834 34.299 40.9834 34.1156 40.9834C28.249 40.25 22.3823 38.2334 17.4323 35.1167C12.849 32.1834 8.81563 28.15 5.88229 23.5667C2.58229 18.6167 0.565625 12.75 0.015625 6.88337C0.015625 6.15004 0.015625 5.41671 0.198958 4.68337C0.565625 3.76671 0.932292 3.21671 1.48229 2.66671C2.03229 2.11671 2.58229 1.56671 3.31562 1.38337C4.04896 1.01671 4.78229 0.833374 5.51562 0.833374H11.0156C12.299 0.833374 13.5823 1.38337 14.6823 2.11671C15.7823 3.03337 16.3323 4.13337 16.5156 5.60004C16.699 7.25004 17.0656 8.90004 17.6156 10.3667C17.9823 11.2834 17.9823 12.3834 17.799 13.4834C17.6156 14.5834 17.0656 15.5 16.3323 16.2334L15.049 17.5167C17.249 20.8167 19.999 23.75 23.4823 25.95L24.7656 24.6667C25.499 23.9334 26.4156 23.3834 27.5156 23.2C28.6156 23.0167 29.5323 23.0167 30.6323 23.3834C32.099 23.9334 33.749 24.3 35.399 24.4834C36.6823 24.6667 37.9656 25.4 38.8823 26.3167C39.799 27.4167 40.1656 28.7 40.1656 29.9834V35.4834C40.1656 36.2167 39.9823 36.95 39.6156 37.6834C39.249 38.4167 38.8823 38.9667 38.3323 39.5167C37.7823 40.0667 37.049 40.4334 36.3156 40.6167C35.949 40.9834 35.2156 40.9834 34.6656 40.9834ZM11.0156 4.50004H5.51562C5.33229 4.50004 4.96562 4.50004 4.78229 4.68337C4.59896 4.68337 4.41563 4.86671 4.23229 5.05004C4.04896 5.23337 3.86562 5.41671 3.86562 5.78337C3.86562 5.96671 3.68229 6.33337 3.86562 6.51671C4.23229 11.8334 6.06562 16.9667 8.99896 21.55C11.749 25.7667 15.2323 29.4334 19.449 32C24.0323 34.9334 29.1656 36.7667 34.4823 37.3167C34.6656 37.3167 35.0323 37.3167 35.2156 37.3167C35.399 37.3167 35.7656 37.1334 35.949 36.95C36.1323 36.7667 36.3156 36.5834 36.3156 36.4C36.499 36.2167 36.499 35.85 36.499 35.6667V30.1667C36.499 29.8 36.3156 29.25 36.1323 28.8834C35.7656 28.5167 35.399 28.3334 35.0323 28.3334C33.199 28.15 31.3656 27.6 29.5323 26.8667C29.1656 26.6834 28.799 26.6834 28.4323 26.8667C28.0656 26.8667 27.699 27.05 27.5156 27.4167L25.1323 29.8C24.5823 30.35 23.6656 30.5334 22.9323 30.1667C17.9823 27.4167 13.949 23.3834 11.199 18.4334C10.8323 17.3334 11.0156 16.4167 11.5656 15.8667L13.949 13.4834C14.1323 13.3 14.3156 12.9334 14.499 12.5667C14.499 12.2 14.499 11.8334 14.499 11.4667C13.7656 9.63338 13.399 7.80004 13.0323 5.96671C13.0323 5.60004 12.6656 5.05004 12.4823 4.86671C11.9323 4.68337 11.5656 4.50004 11.0156 4.50004Z" fill="#2C57DE"/>
</svg>`)

const iconMail = window.webGlobe.global.getSvgDataForImageSrc(`<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.33594 9.16667C6.32342 9.16667 5.5026 9.98748 5.5026 11V33C5.5026 34.0125 6.32342 34.8333 7.33594 34.8333H36.6693C37.6818 34.8333 38.5026 34.0125 38.5026 33V11C38.5026 9.98748 37.6818 9.16667 36.6693 9.16667H7.33594ZM1.83594 11C1.83594 7.96243 4.29837 5.5 7.33594 5.5H36.6693C39.7068 5.5 42.1693 7.96243 42.1693 11V33C42.1693 36.0376 39.7068 38.5 36.6693 38.5H7.33594C4.29837 38.5 1.83594 36.0376 1.83594 33V11Z" fill="#2C57DE"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.12215 11.8501C2.66519 10.9955 3.79819 10.7429 4.65277 11.286L21.092 21.7323C21.3653 21.9025 21.6808 21.9927 22.0028 21.9927C22.3249 21.9927 22.6404 21.9025 22.9137 21.7323C22.9151 21.7314 22.9164 21.7306 22.9178 21.7297L39.3529 11.286C40.2075 10.7429 41.3405 10.9955 41.8835 11.8501C42.4266 12.7046 42.174 13.8376 41.3194 14.3807L24.8646 24.837C24.0068 25.3744 23.015 25.6593 22.0028 25.6593C20.9906 25.6593 19.9989 25.3743 19.1411 24.8369L19.1312 24.8307L2.68624 14.3807C1.83166 13.8376 1.57911 12.7046 2.12215 11.8501Z" fill="#2C57DE"/>
</svg>`)

const isFailedPayment = inject('isFailedPayment')

onBeforeMount(() => {
  if(isFailedPayment) {
    $checkout.checkout5 = $checkout.getFailedPaymentData
    return
  }
  
  if(isEmpty($checkout.checkout5)) {
    $checkout.setStep(1)
    return
  }
})

onBeforeUnmount(() => {
  $checkout.checkout5 = {}
})
</script>

<template>
  <main class="l-page-main">
    <section class="l-page-content l-page-content--checkout">
      <div class="container">
        <div class="row gy-30 gy-lg-40 gx-40">
          <div class="col-12">
            <OrderEnded
              v-if="$checkout?.checkout5?.data?.data && $checkout?.checkout5?.data?.subpage"
              :subpage="$checkout.checkout5.data.subpage"
              :data="{
                ...$checkout.checkout5.data.data,
                success: $checkout.checkout5.data.success
              }"
            />
          </div>
           <div v-if="contactUsSection" class="col-12">
            <h2 class="h5 mb-10">{{ contactUsSection.title }}</h2>
            <div class="desc mb-20">
              <p>{{ contactUsSection.text }}</p>
            </div>
            <div class="row g-20 g-lg-30">
              <div class="col-lg-6 col-xl-4">
                <ContactBox
                  v-if="contactUsSection.phone"
                  variant="variant-2"
                  :item="{
                    icon: iconPhone,
                    contact: contactUsSection.phone,
                    info: contactUsSection.phone_availability
                  }"
                />
              </div>
              <div class="col-lg-6 col-xl-4">
                <ContactBox
                  v-if="contactUsSection.email"
                  variant="variant-2"
                  :item="{
                    icon: iconMail,
                    contact: contactUsSection.email
                  }"
                />
              </div>
            </div>
          </div>
          <div v-if="serviceBoxes" class="col-12">
            <h2 v-if="serviceBoxesTitle" class="h5 mb-20">{{ serviceBoxesTitle }}</h2>
            <div v-html="serviceBoxes"></div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
